import { required } from "vuelidate/lib/validators";

const step7 = ["form.q_7_1"];

const step7Validations = {
  q_7_1: { required }
};

export { step7Validations, step7 };
